module.exports = __webpack_public_path__ + "img/pic_number_40_black.e8f59d7e.png";